'use client';
 
import { useState, useEffect } from 'react';
import LoginCustomizationPanel from './LoginCustomizationPanel';
import UseToast from '../UseToast';
import { IoIosLogIn } from "react-icons/io";
import { FaEllipsisH } from 'react-icons/fa';
 
 
const LoginSlugManager = ({ selectedClient, clients }) => {
  const [slugs, setSlugs] = useState([]);
  const [newSlug, setNewSlug] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const { showMsgSuccessToast, showErrorToast } = UseToast();
 
  useEffect(() => {
    if (selectedClient) {
      fetchClientSlugs();
    }
  }, [selectedClient]);
 
  const fetchClientSlugs = async () => {
    try {
      const response = await fetch(`/api/login-customizations/${selectedClient}`);
      const data = await response.json();
      setSlugs(data.data);
    } catch (error) {
      console.error('Error fetching slugs:', error);
      showErrorToast('Error fetching login slugs');
    }
  };
 
  const generateSlug = () => {
    const client = clients.find(c => c._id === selectedClient);
    if (client) {
      const baseSlug = `${client.first_name}-${client.last_name}`
        .toLowerCase()
        .replace(/\s+/g, '-');
      setNewSlug(`${baseSlug}-login`);
    }
  };
 
  const createSlug = async () => {
    if (!newSlug.trim()) {
      showErrorToast('Please enter a slug');
      return;
    }
 
    setLoading(true);
    try {
      const response = await fetch('/api/login-customizations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          client_id: selectedClient,
          slug: newSlug.trim(),
          header_text: 'Welcome Back',
          button_color: '#007bff',
        }),
      });
 
      const data = await response.json();
 
      if (response.ok) {
        showMsgSuccessToast('Login slug created successfully!');
        setNewSlug('');
        fetchClientSlugs();
        setTimeout(() => setMessage(''), 3000);
      } else {
        showErrorToast(`Error:${data.message}` || 'Error creating slug');
      }
    } catch (error) {
      console.error('Error creating slug:', error);
      showErrorToast('Error creating login slug');
    }
    setLoading(false);
  };
 
  const deleteSlug = async id => {
    // if (!confirm("Are you sure you want to delete this login slug?")) {
    //   return
    // }
 
    try {
      const response = await fetch(`/api/login-customizations/${id}`, {
        method: 'DELETE',
      });
 
      if (response.ok) {
        showMsgSuccessToast('Login slug deleted successfully!');
        fetchClientSlugs();
        setTimeout(() => setMessage(''), 3000);
      } else {
        const data = await response.json();
        showErrorToast(data.error || 'Error deleting slug');
      }
    } catch (error) {
      console.error('Error deleting slug:', error);
      showErrorToast('Error deleting login slug');
    }
  };
 
  if (!selectedClient) {
    return (
      <div className="card mt-4">
        <div className="card-header">
          <h5 className="card-title mb-0">
 
            Login Page Management
          </h5>
        </div>
        <div className="card-body">
          <div className="text-center py-4">
            <i className="fas fa-user-plus mb-3" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
            <p className="text-muted mb-0">Please select a client first</p>
            <small className="text-muted">Choose a client to manage their login slugs</small>
          </div>
        </div>
      </div>
    );
  }
 
  return (
    <div className="card mt-4">
      <div className="card-header">
        <h5 className="card-title mb-0">
          <span style={{ marginRight: '10px' }}><IoIosLogIn /></span>
          Client Login Customization
        </h5>
        <p className="card-text mb-0 mt-2 opacity-75">
          Create and manage unique login URLs for your clients
        </p>
      </div>
      <div className="card-body">
        {message && (
          <div
            className={`alert ${message.includes('Error') ? 'alert-danger' : 'alert-success'} alert-dismissible fade show`}
          >
            <i
              className={`fas ${message.includes('Error') ? 'fa-exclamation-triangle' : 'fa-check-circle'} me-2`}
            ></i>
            {message}
            <button type="button" className="btn-close" onClick={() => setMessage('')}></button>
          </div>
        )}
 
        {/* Create New Slug */}
        <div className="row mb-4" style={{ display: 'flex', alignItems: 'center' }}>
          <div className="col-md-12">
            <div>
              <label className="form-label fw-bold" style={{ marginBottom: '17px' }}>
 
                Create New Login Slug
              </label>
 
              <div
                style={{
                  display: 'grid',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gridTemplateColumns: '2fr 1fr',
                  gap: '2rem',
                }}
              >
                <div className="input-group" style={{ height: '100%', marginBottom: '0px' }}>
                  <span className="input-group-text bg-light">
 
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter unique slug (e.g., client-name-login)"
                    value={newSlug}
                    onChange={e => setNewSlug(e.target.value)}
                    style={{ height: '100%' }}
                  />
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    style={{ height: 'auto' }}
                    onClick={generateSlug}
                    title="Auto-generate slug"
                  >
                    <span style={{ fontSize: '30px' }}><IoIosLogIn /></span>
                  </button>
                </div>
                <div className=" d-flex align-items-end">
                  <button
                    className="btn btn-primary w-100"
                    onClick={createSlug}
                    disabled={loading || !newSlug.trim()}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Creating...
                      </>
                    ) : (
                      <>
 
                        Create Slug
                      </>
                    )}
                  </button>
                </div>
              </div>
 
              <small className="form-text text-muted" style={{ marginTop: '20px' }}>
                URL will be: <strong>yoursite.com/login/{newSlug}</strong>
              </small>
            </div>
          </div>
        </div>
 
        {/* Existing Slugs */}
        <div>
          <h6 className="fw-bold mb-3">
 
            Existing Login Slugs ({slugs.length})
          </h6>
 
          {slugs.length === 0 ? (
            <div className="text-center py-4">
 
              <p className="text-muted mb-0">No login slugs created yet</p>
              <small className="text-muted">Create your first login slug above</small>
            </div>
          ) : (
            <div className="row">
              {slugs.map(slug => (
                <div key={slug.id} className="col-md-6 mb-3">
                  <div className="card border">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-start">
                        <div className="flex-grow-1">
                          <h6 className="card-title mb-1">
 
                            {slug.slug}
                          </h6>
                          <p className="card-text text-muted small mb-2">
                            <strong>URL:</strong> /login/{slug.slug}
                          </p>
                          <p className="card-text text-muted small mb-2">
                            <strong>Header:</strong> {slug.header_text}
                          </p>
                          <div className="d-flex align-items-center">
                            <span className="badge bg-light text-dark me-2">
 
                              {slug.button_color}
                            </span>
                            <div
                              className="color-preview rounded-circle"
                              style={{
                                width: '20px',
                                height: '20px',
                                backgroundColor: slug.button_color,
                                border: '2px solid #dee2e6',
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="dropdown">
                          <button
                            className="btn btn-sm btn-outline-secondary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                          >
                            <FaEllipsisH />
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <a
                                className="dropdown-item"
                                href={`/login/${slug.slug}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
 
                                Preview
                              </a>
                            </li>
                            <li>
                              <hr className="dropdown-divider" />
                            </li>
                            <li>
                              <button
                                className="dropdown-item text-danger"
                                onClick={() => deleteSlug(slug._id)}
                              >
 
                                Delete
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <LoginCustomizationPanel selectedClient={selectedClient} clients={clients} slugs={slugs} />
    </div>
  );
};
 
export default LoginSlugManager;
 